<template>
  <div style="padding: 10px;">
    <p id="title">家庭医生签约服务协议书</p>
    <p>
      甲方：<u
        >{{ signInfo.cityName }}{{ signInfo.countyName
        }}{{ signInfo.orgName }}</u
      >
    </p>
    <p>
      乙方：<u>{{ signInfo.residentName }}</u>
    </p>
    <table
      border-collapse="collapse"
      cellspacing="0"
      style="width: 100%"
      class="ignore"
    >
      <tr>
        <th style="background: #f0f0f0">成员</th>
        <th style="background: #f0f0f0">性别</th>
        <th style="background: #f0f0f0">年龄</th>
        <th style="background: #f0f0f0">身份证号</th>
        <th style="background: #f0f0f0">社会保障号</th>
        <th style="background: #f0f0f0">关爱等级</th>
        <th style="background: #f0f0f0">手机号码</th>
      </tr>
      <tr>
        <td>{{ signInfo.residentName }}</td>
        <td v-if="signInfo.gender == '1'">男</td>
        <td v-else>女</td>
        <td>{{ signInfo.age }}</td>
        <td>{{ signInfo.identity }}</td>
        <td></td>
        <td></td>
        <td>{{ signInfo.phone }}</td>
      </tr>
      <tr>
        <td colspan="3" style="background: #f0f0f0">
          家庭住址
        </td>
        <td colspan="4">{{ signInfo.address }}</td>
      </tr>
      <tr>
        <td colspan="8">
          <div
            style="display: flex;align-items: center;justify-content: center;"
          >
            <input type="radio" disabled /> <label>接受上门服务</label>
            <input type="radio" disabled /> <label>拒绝上门服务</label>
          </div>
        </td>
      </tr>
    </table>

    <p>
      甲乙双方本着平等、尊重和自愿的原则，签订此协议，接受以下条款的约定
    </p>
    <p>
      甲乙双方共同确定<u>{{ signInfo.teamName }}</u
      >为乙方的家庭医生服务团队
    </p>
    <table
      border="1"
      border-collapse="collapse"
      cellspacing="0"
      style="width: 100%"
    >
      <tr style="background: #f0f0f0">
        <th>家庭医生团队成员</th>
        <th>姓名</th>
        <th>职称</th>
        <th>联系手机</th>
      </tr>
      <tr v-for="(item, index) in DoctorList" :key="index">
        <td v-if="item.teamLeader">团队长</td>
        <td v-else>
          <span v-if="item.teamMemberType == '0'">全科医生</span>
          <span v-else-if="item.teamMemberType == '1'">专科医生</span>
          <span v-else-if="item.teamMemberType == '2'">社区护士</span>
          <span v-else-if="item.teamMemberType == '3'">公共卫生人员</span>
        </td>
        <td>{{ item.realname }}</td>
        <td>
          <span v-if="item.profTitle === '0'">初级</span>
          <span v-else-if="item.profTitle === '1'">中级</span>
          <span v-else-if="item.profTitle === '3'">高级</span>
          <span v-else-if="item.profTitle === '99'">其他</span>
        </td>
        <td>{{ item.mobilePhone }}</td>
      </tr>
    </table>

    <p>一、甲方职责</p>
    <p>（一）为乙方提供以下个性化签约服务</p>
    <p>
      1.在基本公共卫生服务基础上，根据乙方需求，制定健康管理方案，提供个性化服务建议、中医药专项补充服务建议等。
    </p>
    <p>
      2.与甲方沟通共同确定签约服务内容、时间和频次。具体内容附后。
    </p>
    <p>3.根据协议内容履行签约服务。</p>
    <p>（二）为乙方家庭成员共同提供以下服务：</p>
    <p>向老年人子女推送健康体检报告和健康状况变化情况。</p>
    <p>二、乙方职责</p>
    <p>（一）提供健康相关信息</p>
    <p>
      乙方及家庭成员主动配合甲方开展以上服务，将身体健康情况、变化情况及时告知家庭医生，并保证信息资料的真实合法性。
    </p>
    <p>（二）预约协商上门服务和非工作时间提供服务</p>
    <p>
      如需甲方上门服务时，乙方应提前与甲方预约或沟通，商定服务形式和时间。
    </p>
    <p>（三）执行甲方提供的疾病防治方案</p>
    <p>
      积极配合并参与甲方开展的疾病防治相关活动，认真执行甲方提供的疾病防控措施。
    </p>
    <p>（四）承担违约后果</p>
    <p>
      1.乙方隐瞒病史或提供虚假资料、不执行甲方提供的诊疗方案等非甲方导致的不利因素，影响诊疗效果，后果由乙方承担。
    </p>
    <p>
      2.乙方有就医需求（非紧急状态）时，应首先联系甲方，因个人原因未经甲方转诊，影响就医费用结算或造成其他不良后果的，由乙方承担责任。
    </p>
    <p>（五）反馈甲方服务情况</p>
    <p>
      乙方如对团队成员服务不满意，可向甲方投诉，乃至更换签约医生。
    </p>
    <p>三、服务收费</p>
    <p>
      1.乙方按照自愿原则选择服务，由甲方提供相应服务，服务费为<u>{{ money }}</u
      >元/年。（具体内容附后）
    </p>
    <p>
      2.服务过程中，根据医生判断及患者临时需求增加的服务内容，按照国家相关规定和当地物价部门规定收费。
    </p>
    <p>
      3.乙方应于<u>{{ signInfo.signTime }}</u
      >前将签约服务费缴纳至甲方机构指定科室，不得由签约团队成员代收。
    </p>
    <p>
      四、保密条款：签约居民授权其所签约的家庭医生及其团队成员可调阅其电子健康档案和在其他医疗机构的诊疗记录信息。甲方有义务对签约居民的电子健康档案和在其他医疗机构的诊疗记录信息予以保密。除法律法规规定外，未经签约居民允许，不得泄露给第三方。
    </p>
    <p>
      五、本协议未尽事宜，经双方协商一致，签订补充协议，补充协议具有同等效力。
    </p>
    <p>
      六、本协议解释权归甲方。协议一式两份，甲、乙双方各执一份，自双方签字之日起生效，有效期
      <u>{{ signInfo.signYears }}</u> 年， 自<u>{{ signInfo.signTime }}</u> ---
      <u>{{ endDate }}</u
      >。
    </p>
    <div class="fontbox">
      <div>
        <span>甲方（团队长）签字 </span>
        <div style="width: 80px;height: 80px;margin: 10px 0;"></div>
        <span>时间</span>
      </div>
      <div>
        <span>乙方（居民）签字 </span>
        <div style="width: 80px;height: 80px;margin: 10px 0;">
          <img
            v-if="imageUrl"
            :src="imageUrl"
            alt="Captured Image"
            style="width: 100%; height:100%"
          />
        </div>
        <span>时间</span>
      </div>
    </div>
    <van-popover
      v-model="showPopover"
      trigger="click"
      placement="top"
      :actions="actions"
      @select="onSelect"
    >
      <template #reference>
        <van-button icon="plus" type="primary"></van-button>
      </template>
    </van-popover>
    <van-popup
      v-model="showSignaturePad"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div style="padding: 20px;">
        <canvas
          id="signatureCanvas"
          width="330"
          height="200"
          style="border: 1px solid #ccc; display: block; margin: 0 auto;"
        ></canvas>
        <div class="changefont">
          <van-button plain hairline type="primary" @click="clearSignature"
            >清除</van-button
          >
          <van-button type="primary" @click="saveSignature">保存</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import dayjs from "dayjs";
import api from "@/services/api/api";
import { Popover, Button, Popup } from "vant";
export default {
  props: {
    signInfo: {
      type: Object,
      default: () => {},
    },
    DoctorList: {
      type: Array,
      default: () => [],
    },
    money: {
      type: Number,
      default: 0,
    },
  },
  components: {
    [Popover.name]: Popover,
    [Button.name]: Button,
    [Popup.name]: Popup,
  },
  computed: {
    endDate() {
      return dayjs(this.signInfo.signTime)
        .add(this.signInfo.signYears, "year")
        .subtract(1, "day")
        .format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      showPopover: false,
      actions: [
        { text: "签字", value: "1" },
        { text: "拍照", value: "2" },
      ],
      imageUrl: null,
      FileNo: null,
      showSignaturePad: false,
      isSignaturePadInitialized: false,
    };
  },
  mounted() {
    // Signature pad will be initialized when popup opens
  },
  methods: {
    onSelect(action) {
      console.log(action);
      if (action.value == "2") {
        this.takePhoto();
      } else {
        this.showSignaturePad = true;
        if (!this.isSignaturePadInitialized) {
          this.$nextTick(() => {
            this.initSignaturePad();
            this.isSignaturePadInitialized = true;
          });
        }
      }
    },
    takePhoto() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.capture = "camera";
      input.onchange = (event) => {
        const file = event.target.files[0];
        if (file) {
          this.handleFile(file);
          this.clearSignature();
        }
      };
      input.click();
    },
    handleFile(file) {
      this.imageUrl = URL.createObjectURL(file);
      console.log("Photo captured:", file, this.imageUrl);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("appId", this.signInfo.appId);
      api.uploadFile(formData).then((res) => {
        console.log("File uploaded:", res, res.data);
        this.FileNo = res.data;
        this.$emit("signature-uploaded", res.data);
        if (res.code == 200) {
          api
            .getFile({ appId: this.signInfo.appId, fileNo: res.data })
            .then((response) => {
              console.log("File retrieved:", response);
              this.imageUrl = response.data;
            });
        }
      });
    },
    initSignaturePad() {
      const canvas = document.getElementById("signatureCanvas");
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#000";
      let drawing = false;
      canvas.addEventListener("mousedown", (e) => {
        drawing = true;
        const rect = canvas.getBoundingClientRect();
        ctx.beginPath();
        ctx.moveTo(e.clientX - rect.left, e.clientY - rect.top);
      });
      canvas.addEventListener("mousemove", (e) => {
        if (drawing) {
          const rect = canvas.getBoundingClientRect();
          ctx.lineTo(e.clientX - rect.left, e.clientY - rect.top);
          ctx.stroke();
        }
      });
      canvas.addEventListener("mouseup", () => {
        drawing = false;
      });
      canvas.addEventListener("mouseout", () => {
        drawing = false;
      });
      // Touch events
      canvas.addEventListener("touchstart", (e) => {
        e.preventDefault();
        drawing = true;
        const touch = e.touches[0];
        const rect = canvas.getBoundingClientRect();
        ctx.beginPath();
        ctx.moveTo(touch.clientX - rect.left, touch.clientY - rect.top);
      });
      canvas.addEventListener("touchmove", (e) => {
        e.preventDefault();
        if (drawing) {
          const touch = e.touches[0];
          const rect = canvas.getBoundingClientRect();
          ctx.lineTo(touch.clientX - rect.left, touch.clientY - rect.top);
          ctx.stroke();
        }
      });
      canvas.addEventListener("touchend", () => {
        drawing = false;
      });
    },
    clearSignature() {
      const canvas = document.getElementById("signatureCanvas");
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    },
    saveSignature() {
      const canvas = document.getElementById("signatureCanvas");
      const dataURL = canvas.toDataURL("image/png");
      this.imageUrl = dataURL;
      this.showSignaturePad = false;
      // Upload the signature
      const blob = this.dataURLToBlob(dataURL);
      const formData = new FormData();
      formData.append("file", blob, "signature.png");
      formData.append("appId", this.signInfo.appId);
      api.uploadFile(formData).then((res) => {
        console.log("Signature uploaded:", res);
        this.FileNo = res.data;
        this.$emit("signature-uploaded", res.data);
      });
    },
    dataURLToBlob(dataURL) {
      const arr = dataURL.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
  },
};
</script>

<style scoped>
#title {
  font-weight: bold;
  text-align: center;
  font-size: 16px;
}
.fontbox {
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  margin-bottom: 5vh;
}
.fontbox > div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.changefont {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}
.changefont > .van-button--normal {
  width: 100px;
  height: none;
  border-radius: 5px;
  font-size: 18px;
}
p {
  font-size: 14px;
  text-align: left;
}
table,
th,
td {
  font-size: 12px;
  border: 1px solid #ccc;
}
.van-button--normal {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  font-size: 22px;
}
.van-popover__wrapper {
  position: fixed;
  left: 1rem;
  bottom: 50px;
}
</style>
